
(async () => {
  const productId = window.meta.product.id;
  const currentPrice = parseFloat(document.querySelector('.price-item--regular')?.textContent.replace(/[^\d.]/g, ''));

  const response = await fetch(`/products/${productId}/lowest-price`);
  const data = await response.json();
  const lowestPrice = parseFloat(data?.lowest_price_last_30_days);

  if (!isNaN(currentPrice) && !isNaN(lowestPrice) && currentPrice < lowestPrice) {
    const el = document.createElement('div');
    el.className = "lowest-price-omnibus";
    el.style.marginTop = '10px';
    el.style.fontWeight = 'bold';
    el.innerText = `Prezzo più basso negli ultimi 30gg: ${lowestPrice.toFixed(2)}€`;
    document.querySelector('.product__price')?.appendChild(el);
  }
})();
